(function () {
  'use strict';

  if (window.__rnrCardHoverScopeLoaded) return;
  window.__rnrCardHoverScopeLoaded = true;

  var observer = null;

  function pointInRect(event, rect) {
    return Boolean(
      rect &&
        rect.width > 0 &&
        rect.height > 0 &&
        event.clientX >= rect.left &&
        event.clientX <= rect.right &&
        event.clientY >= rect.top &&
        event.clientY <= rect.bottom
    );
  }

  function isPointerOverVisualTarget(card, event) {
    var media = card.querySelector('.card__media');
    if (media && pointInRect(event, media.getBoundingClientRect())) return true;

    var headings = card.querySelectorAll('.card__heading');
    for (var i = 0; i < headings.length; i += 1) {
      var heading = headings[i];
      var rect = heading.getBoundingClientRect();
      if (rect.width === 0 || rect.height === 0) continue;

      var style = window.getComputedStyle(heading);
      if (style.display === 'none' || style.visibility === 'hidden') continue;

      if (pointInRect(event, rect)) return true;
    }

    return false;
  }

  function bindCard(card) {
    if (!card || card.nodeType !== 1 || card.dataset.rnrVisualHoverBound === 'true') return;
    card.dataset.rnrVisualHoverBound = 'true';

    card.addEventListener('pointermove', function (event) {
      card.classList.toggle('is-rnr-card-visual-hover', isPointerOverVisualTarget(card, event));
    });

    card.addEventListener('pointerleave', function () {
      card.classList.remove('is-rnr-card-visual-hover');
    });
  }

  function bindCards(root) {
    var scope = root && root.querySelectorAll ? root : document;

    if (scope.matches && scope.matches('.product-card-wrapper')) {
      bindCard(scope);
    }

    var cards = scope.querySelectorAll('.product-card-wrapper');
    Array.prototype.forEach.call(cards, bindCard);
  }

  function initObserver() {
    if (observer || !document.body) return;

    observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        Array.prototype.forEach.call(mutation.addedNodes || [], function (node) {
          if (node.nodeType === 1) bindCards(node);
        });
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  function init() {
    bindCards(document);
    initObserver();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    bindCards(event.target || document);
  });
})();
